import React, { useContext, useEffect, useState } from "react";
import Hierarchy from "./Hierarchy";
import { Box, Tab, Tabs } from "@mui/material";
import AddButton from "../../components/300/AddButton";
import OfficeContext from "../../context/OfficeContext";
import useAuth from "../../hooks/useAuth";
import Office from "./Office";
import HierarchyManagment from "./HierarchyManagment";
import HierarchyList from "./HierarchyList";
import { useLocation, useNavigate } from "react-router-dom";
import CustomizedSnackbars from "../300/curriculum/CustomizedSnackbars";
// import api from "../../api/mainApi";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";
function OfficeManagment() {
  let navigate = useNavigate();
  let location = useLocation();
  let api = useAxiosPrivate();
  console.log(location);
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [message, setMessage] = useState({
    message: "",
    type: "",
  });

  const [value, setValue] = React.useState("course");
  const { user } = useAuth();
  const officeContext = useContext(OfficeContext);
  useEffect(() => {
    api
      .get("office/offices")
      .then((res) => {
        officeContext.officeDispatch({
          type: "loadOffice",
          offices: res.data.offices,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (location.state?.message) {
      setSnackBarOpen(location.state.open);
      setMessage(location.state.message);
    }
  }, []);

  let buttonProps = {
    onClick: () => {
      navigate("addHierarchy", {
        state: { operation: "add", id: null },
      });
    },
    link:
      officeContext.tabState == "office"
        ? { label: "Add Office", href: "/office_management/addOffice" }
        : { label: "Add Hierrarchy", href: null },
  };

  return (
    //<Box
    //  sx={{
    //    display: "flex",
    //    flexDirection: "column",
    //    gap: "0.7rem",
    //    width: "100%",
    //  }}
    //>
    <>
      <Tabs
        value={officeContext.tabState}
        onChange={(event, newValue) => {
          officeContext.setTabState(newValue);
        }}
      >
        {user.roles.includes(301) && (
          <Tab label="Office List" value={"office"} />
        )}
        {user.roles.includes(351) && (
          <Tab label="Hierarchy Setting" value={"hierarchy"} />
        )}
      </Tabs>

      {user.roles.includes(officeContext.tabState === "office" ? 303 : 352) && (
        <AddButton {...buttonProps} />
      )}
      {/*<Box>*/}
      {officeContext.tabState === "office" ? <Office /> : <HierarchyList />}
      {snackBarOpen && (
        <CustomizedSnackbars
          {...{ setSnackBarOpen, snackBarOpen, message, overlay: true }}
        />
      )}
    </>
    //</Box>
    //</Box>
  );
}

export default OfficeManagment;
